<ng-container *ngIf="viewModel">
    <bs-linear-bet-builder-notification
        *ngIf="showBetBuilderNotification"
        [betBuilderNotification]="viewModel.betBuilderNotification"></bs-linear-bet-builder-notification>

    <bs-linear-odds-change-notification
        *ngIf="isOfferChanged"
        [isPlacementError]="viewModel.isBetPlacementOfferChanged"></bs-linear-odds-change-notification>

    <bs-linear-combo-prevention-notification *ngIf="viewModel.hasComboPrevention" [betslipType]="viewModel.betslipType">
    </bs-linear-combo-prevention-notification>

    <bs-linear-errors-list *ngIf="showBetslipErrors" [viewModel]="viewModel.errors" [tokensContext]="tokensContext"></bs-linear-errors-list>
</ng-container>
